function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Table, message, Descriptions, Button, Tag, DatePicker, Form, Tabs, Space, Skeleton, Drawer, Modal } from "antd";
import moment from 'moment';
import { useOutletContext } from "react-router-dom";
import Common from "../components/includes/Common";
import { Folder2Open, FolderSymlinkFill, PencilSquare, TrashFill, Alexa, CardHeading, ExclamationCircleFill, ShareFill } from "react-bootstrap-icons";
import Moment from "react-moment";
import MailView from "../components/MailView";
import ForwardMail from "../components/forms/ForwardMail";
import EditMail from "../components/forms/EditMail";
import CommentMail from "../components/forms/CommentMail";
import ManagerSignaturePadView from "../components/ManagerSignaturePadView";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var confirm = Modal.confirm;
var Mails = function Mails() {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    mails = _useState2[0],
    setMails = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(moment().startOf("month").format()),
    _useState6 = _slicedToArray(_useState5, 2),
    from = _useState6[0],
    setFrom = _useState6[1];
  var _useState7 = useState(moment().endOf("month").format()),
    _useState8 = _slicedToArray(_useState7, 2),
    to = _useState8[0],
    setTo = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    currentMail = _useState0[0],
    setCurrentMail = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isMailDetailsVisible = _useState10[0],
    setIsMailDetailsVisible = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isForwardMailVisible = _useState12[0],
    setIsForwardMailVisible = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isEditMailVisible = _useState14[0],
    setIsEditMailVisible = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isCommentMailVisible = _useState16[0],
    setIsCommentMailVisible = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    hasDataChanged = _useState18[0],
    setHasDataChanged = _useState18[1];
  var _useOutletContext = useOutletContext(),
    _useOutletContext2 = _slicedToArray(_useOutletContext, 2),
    isMailCreated = _useOutletContext2[0],
    setIstMailCreated = _useOutletContext2[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    assignments = _useState20[0],
    setAssignments = _useState20[1];
  var onSearchFinish = function onSearchFinish(values) {
    setMails([]);
    setFrom(values.range[0]._d);
    setTo(values.range[1]._d);
  };
  var onEditClick = function onEditClick(m) {
    setCurrentMail(m);
    setIsEditMailVisible(true);
  };
  var onDeleteClick = function onDeleteClick(m) {
    setCurrentMail(m);
    confirm({
      title: "Voulez-vous vraiment supprimer le courrier ?",
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {
        size: 40
      }),
      content: "~ " + m.subject + " ~ de " + m.sender,
      onOk: function onOk() {
        axios.get(Common.baseApiUrl + "deletemail/" + m.id.toString() + "/" + Common.currentUser.id).then(function (response) {
          if (response.data.status == 200) {
            message.success({
              content: response.data.message,
              delay: 6
            });
            setHasDataChanged(true);
          } else {
            message.error({
              content: response.data.message,
              delay: 6
            });
          }
        })["catch"](function (error) {
          message.error({
            content: "Une erreur est survenue",
            delay: 6
          });
        })["finally"](function () {});
      }
    });
  };
  var onForwardClick = function onForwardClick(m) {
    setCurrentMail(m);
    setIsForwardMailVisible(true);
  };
  var onCommentClick = function onCommentClick(m) {
    setCurrentMail(m);
    setIsCommentMailVisible(true);
  };
  var tabsContent = [{
    key: 1,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(ShareFill, {
        size: 23
      }), " COURRIERS ASSIGN\xE9S"]
    }),
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Form, {
        size: "large",
        onFinish: onSearchFinish,
        layout: "horizontal",
        children: /*#__PURE__*/_jsxs(Space, {
          direction: "horizontal",
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "range",
            rules: [{
              required: true,
              message: "Champs obligatoire"
            }],
            children: /*#__PURE__*/_jsx(RangePicker, {})
          }), /*#__PURE__*/_jsx(Form.Item, {
            children: /*#__PURE__*/_jsx(Button, {
              type: "primary",
              htmlType: "submit",
              children: /*#__PURE__*/_jsx("b", {
                children: "RECHERCHE"
              })
            })
          })]
        })
      }), assignments.length > 0 && assignments.map(function (a) {
        return /*#__PURE__*/_jsx("div", {
          className: "white-bg cool-radius",
          style: {
            marginBottom: "5px"
          },
          children: /*#__PURE__*/_jsxs(Descriptions, {
            column: 2,
            extra: /*#__PURE__*/_jsx(Button, {
              onClick: function onClick() {
                setCurrentMail(a.mail);
                setIsMailDetailsVisible(true);
              },
              icon: /*#__PURE__*/_jsx(Folder2Open, {
                size: 22
              }),
              type: "primary",
              children: /*#__PURE__*/_jsx("b", {
                children: "OUVRIR"
              })
            }),
            title: /*#__PURE__*/_jsx("b", {
              children: a.mail.sender
            }),
            children: [/*#__PURE__*/_jsx(Descriptions.Item, {
              label: "Date",
              children: /*#__PURE__*/_jsx(Moment, {
                format: "DD/MM/YYYY",
                children: a.created_at
              })
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              label: "Objet",
              children: a.mail.subject
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: "Type",
              children: [a.mail.type == 0 && /*#__PURE__*/_jsx(Tag, {
                color: "red",
                children: "Entrant"
              }), a.mail.type == 1 && /*#__PURE__*/_jsx(Tag, {
                color: "green",
                children: "Sortant"
              }), a.mail.type == 2 && /*#__PURE__*/_jsx(Tag, {
                color: "yellow",
                children: "Entrant Portail"
              })]
            }), /*#__PURE__*/_jsxs(Descriptions.Item, {
              label: "Priorit\xE9",
              children: [a.mail.priority == 0 && /*#__PURE__*/_jsx(Tag, {
                color: "lime",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Faible"
                })
              }), a.mail.priority == 1 && /*#__PURE__*/_jsx(Tag, {
                color: "#87d068",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Normal"
                })
              }), a.mail.priority == 2 && /*#__PURE__*/_jsx(Tag, {
                color: "#FF9C9A",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Elev\xE9e"
                })
              }), a.mail.priority == 3 && /*#__PURE__*/_jsx(Tag, {
                color: "#F50",
                children: /*#__PURE__*/_jsx("b", {
                  children: "Urgent"
                })
              })]
            }), /*#__PURE__*/_jsx(Descriptions.Item, {
              span: 2,
              children: /*#__PURE__*/_jsxs(Space, {
                style: {
                  borderRadius: '5px',
                  background: '#A0DB80',
                  padding: '7px'
                },
                direction: "horizontal",
                children: [/*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    return onForwardClick(a.mail);
                  },
                  children: /*#__PURE__*/_jsx(FolderSymlinkFill, {
                    size: 25
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    return onEditClick(a.mail);
                  },
                  children: /*#__PURE__*/_jsx(PencilSquare, {
                    size: 25
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    return onDeleteClick(a.mail);
                  },
                  children: /*#__PURE__*/_jsx(TrashFill, {
                    size: 25
                  })
                }), /*#__PURE__*/_jsx(Button, {
                  type: "link",
                  onClick: function onClick() {
                    return onCommentClick(a.mail);
                  },
                  children: /*#__PURE__*/_jsx(Alexa, {
                    size: 25
                  })
                })]
              })
            })]
          })
        }, a.id);
      }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    key: 2,
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CardHeading, {
        size: 23
      }), " PARAFEUR"]
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(ManagerSignaturePadView, {
        userId: Common.currentUser.id
      })
    })
  }];
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getassignedmails/" + from + "/" + to + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setAssignments(response.data.assignments);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
      setIstMailCreated(false);
    });
  }, [from, to, isMailCreated]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 9,
          md: 10,
          children: /*#__PURE__*/_jsx(Tabs, {
            destroyOnClose: true,
            items: tabsContent,
            animated: true
          })
        })
      })
    }), currentMail && /*#__PURE__*/_jsx(Drawer, {
      title: /*#__PURE__*/_jsx("b", {
        children: currentMail.subject
      }),
      width: "90%",
      visible: isMailDetailsVisible,
      onClose: function onClose() {
        setIsMailDetailsVisible(false);
      },
      children: /*#__PURE__*/_jsx(MailView, {
        m: currentMail
      })
    }), currentMail && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Modal, {
        destroyOnClose: true,
        footer: null,
        title: /*#__PURE__*/_jsx("b", {
          children: currentMail.subject
        }),
        visible: isForwardMailVisible,
        onCancel: function onCancel() {
          setIsForwardMailVisible(false);
        },
        children: /*#__PURE__*/_jsx(ForwardMail, {
          m: currentMail,
          handler: function handler() {
            onOperationSuccess();
            setIsForwardMailVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        destroyOnClose: true,
        footer: null,
        title: /*#__PURE__*/_jsx("b", {
          children: currentMail.subject
        }),
        width: "90%",
        visible: isEditMailVisible,
        onCancel: function onCancel() {
          setIsEditMailVisible(false);
        },
        children: /*#__PURE__*/_jsx(EditMail, {
          m: currentMail,
          handler: function handler() {
            onOperationSuccess();
            setIsEditMailVisible(false);
          }
        })
      }), /*#__PURE__*/_jsx(Modal, {
        destroyOnClose: true,
        footer: null,
        title: /*#__PURE__*/_jsx("b", {
          children: currentMail.subject
        }),
        width: "90%",
        visible: isCommentMailVisible,
        onCancel: function onCancel() {
          setIsCommentMailVisible(false);
        },
        children: /*#__PURE__*/_jsx(CommentMail, {
          m: currentMail,
          handler: function handler() {
            setIsCommentMailVisible(false);
            onOperationSuccess();
          }
        })
      })]
    })]
  });
};
export default Mails;